import React from 'react';
import { blogs } from '../data/mock';
import { ArrowRight, Calendar, User } from 'lucide-react';
import { Link } from 'react-router-dom';

const Blogs = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-black to-gray-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-8 h-8 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg flex items-center justify-center shadow-lg shadow-purple-500/50">
              <div className="w-4 h-4 bg-white rounded-sm"></div>
            </div>
            <span className="text-purple-400 font-semibold uppercase tracking-wider text-sm">
              OUR BLOGS
            </span>
          </div>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4"
            style={{ letterSpacing: '0.1em' }}
          >
            The Latest News & Blog
          </h2>
          <div className="h-1 w-32 bg-gradient-to-r from-purple-500 to-blue-500 mx-auto rounded-full"></div>
        </div>

        {/* Blog Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog, index) => (
            <div
              key={blog.id}
              className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl overflow-hidden shadow-lg shadow-purple-900/30 hover:shadow-2xl hover:shadow-purple-900/50 transition-all duration-300 group border border-purple-500/20"
              style={{
                animation: `fadeInUp 0.6s ease-out ${index * 0.2}s both`
              }}
            >
              {/* Image */}
              <div className="relative overflow-hidden h-56">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-60 group-hover:opacity-80 transition-opacity"></div>
              </div>

              {/* Content */}
              <div className="p-6 space-y-4">
                {/* Meta */}
                <div className="flex items-center space-x-4 text-sm text-gray-500">
                  <div className="flex items-center space-x-1">
                    <Calendar className="h-4 w-4 text-purple-400" />
                    <span className="text-gray-400">{blog.date}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <User className="h-4 w-4 text-purple-400" />
                    <span className="text-gray-400">by {blog.author}</span>
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-white group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-purple-400 group-hover:to-blue-400 group-hover:bg-clip-text transition-all">
                  {blog.title}
                </h3>

                {/* Excerpt */}
                <p className="text-gray-400">{blog.excerpt}</p>

                {/* Read More Link */}
                <Link
                  to={`/blogs/${blog.slug}`}
                  className="inline-flex items-center text-purple-400 font-semibold hover:text-purple-300 group/link"
                >
                  Read More
                  <ArrowRight className="ml-2 h-4 w-4 group-hover/link:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blogs;